import SidebarLayout from "components/Layout/Layout";
import { useTheme } from "components/provider/theme";
import TinyMce from 'components/GbCpn/TinyMce';

import { useState } from "react";
import { API_URL } from "env";
import { toast } from "react-toastify";

const CreateEvent = () => {
    const { theme } = useTheme();
    const [languageList, setLanguageList] = useState(['en', 'vi']);
    const [activeLang, setActiveLang] = useState('en');
    const [forceCreate, setForceCreate] = useState(false);
    const [eventType, setEventType] = useState('news');
    const [title, setTitle] = useState({
        en: '',
        vi: ''
    });
    const [subTitle, setSubTitle] = useState({
        en: '',
        vi: ''
    });
    const [description, setDescription] = useState({
        en: '',
        vi: ''
    });

    function checkData() {
        if (forceCreate) {
            return true;
        }
        for (const lang of languageList) {
            if (!title[lang as 'en' | 'vi']) {
                toast.error(`Title (${lang.toUpperCase()}) is required`);
                return false;
            }
            if (!subTitle[lang as 'en' | 'vi']) {
                toast.error(`Sub Title (${lang.toUpperCase()}) is required`);
                return false;
            }
            if (!description[lang as 'en' | 'vi']) {
                toast.error(`Description (${lang.toUpperCase()}) is required`);
                return false;
            }
        }
        return true;
    }

    async function createEvent() {
        if (checkData()) {
            await postEvent();
        }
    }

    async function postEvent() {
        try {
            const response = await fetch(`${API_URL}api/v1/be/events`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    title,
                    subtitle: subTitle,
                    description,
                    type: eventType,
                    active: false,
                })
            });
            const data = await response.json();
            if (data.status) {
                toast.success(`Event created successfully`);
                window.location.href = '/events';
            } else {
                alert(data.message || 'Failed to create event');
            }
        }
        catch (error) {
            console.error('Error creating event:', error);
        }
    }

    return (
        <SidebarLayout
            title={(
                <h4 className={`text-2xl font-bold !m-0 ${theme === "light" ? 'text-gray-800' : ''} py-4`}>
                    Event Dashboard
                </h4>
            )}
        >
            <div className="w-full ">
                <div className={`rounded-lg shadow-sm ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} p-4`}>
                    <h2 className="text-xl font-semibold mb-4">Create New Event</h2>
                    <div className="mb-4">
                        <div className="mb-4">
                            <label className="block mb-2 font-medium">Select Language:</label>
                            <div className="flex !space-x-2">
                                <select className="p-2 border border-gray-300 w-full rounded" value={activeLang} onChange={(e) => setActiveLang(e.target.value)}>
                                    {languageList.map(lang => (
                                        <option key={lang} value={lang}>{lang.toUpperCase()}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="mb-4 flex items-center !space-x-2">
                            <input
                                checked={forceCreate}
                                onChange={(e) => setForceCreate(e.target.checked)}
                                type="checkbox"
                                aria-label="Force create current event"
                                className="mr-2"
                            />
                            <span>Force create event even if validation fails for other languages</span>
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2 font-medium">Title ({activeLang.toUpperCase()}):</label>
                            <input
                                type="text"
                                aria-label="Title"
                                value={title[activeLang as 'en' | 'vi']}
                                onChange={(e) => setTitle({ ...title, [activeLang]: e.target.value })}
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2 font-medium">Sub Title ({activeLang.toUpperCase()}):</label>
                            <input
                                type="text"
                                aria-label="Sub Title"
                                value={subTitle[activeLang as 'en' | 'vi']}
                                onChange={(e) => setSubTitle({ ...subTitle, [activeLang]: e.target.value })}
                                className="w-full p-2 border border-gray-300 rounded"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2 font-medium">Event Type:</label>
                            <select
                                value={eventType}
                                onChange={(e) => setEventType(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded"
                            >
                                <option value="news">News</option>
                                <option value="update">Update</option>
                                <option value="announcement">Announcement</option>
                                <option value="promotion">Promotion</option>
                                <option value="challenge">Challenge</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2 font-medium">Description ({activeLang.toUpperCase()}):</label>
                            <TinyMce
                                defaultValue={description[activeLang as 'en' | 'vi']}
                                onChange={(content) => setDescription({ ...description, [activeLang]: content })}
                            />
                        </div>

                        <div className="flex space-x-2 justify-end">
                            <button
                                onClick={() => 
                                    createEvent()
                                }
                                className="px-4 py-2 bg-blue-600 !text-white rounded hover:bg-blue-700"
                            >
                                Create Event
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </SidebarLayout>)
};

export default CreateEvent;